export enum ReceivableDocumentType {
  INVOICE_FROM_PLATFORM = "INVOICE_FROM_PLATFORM",
  EXCHANGE_CONTRACT = "EXCHANGE_CONTRACT",
}

export const RECEIVABLE_DOCUMENT_TYPE_LABELS: Record<ReceivableDocumentType, string> = {
  [ReceivableDocumentType.INVOICE_FROM_PLATFORM]: "Recibo",
  [ReceivableDocumentType.EXCHANGE_CONTRACT]: "Cálculo",
};

export interface ReceivableDocument {
  id: string;
  receivableId: string;
  documentUrl: string;
  documentType: ReceivableDocumentType;
  description?: string | null;
  createdBy?: string | null;
  createdAt: string;
  updatedAt?: string;
  file?: File;
}

export interface CreateReceivableDocumentPayload {
  receivableId: string;
  documentType: ReceivableDocumentType;
  description?: string;
  file?: File;
  documentUrl?: string;
}

export interface UpdateReceivableDocumentPayload {
  id: string;
  receivableId?: string;
  documentType?: ReceivableDocumentType;
  description?: string;
  file?: File;
  documentUrl?: string;
}

export interface PendingReceivableDocument {
  id: string;
  documentType: ReceivableDocumentType;
  description?: string;
  documentUrl?: string;
  file?: File;
  createdAt: string;
  updatedAt?: string;
}

